import { ComponentIds, HierarchyUtils } from '@inter-ikea-core/core';
import { DistanceMeasurementComponent, PlannerEcsSystem, ProductType } from '@inter-ikea-storageone/range';
import { Direction } from '@inter-ikea-storageone/range/src/core-api/components/DistanceMeasurementComponent';
/**
 * Adds DistanceMeasurementComponent to BROR cabinets depending on if they are placed in
 * section or on wall/floor
 */
export class BrorDistanceMeasurementSystem extends PlannerEcsSystem {
    constructor(coreApi) {
        super(coreApi, 'BrorDistanceMeasurementSystem', ComponentIds.MOVED_TO_VALID_SNAP_POSITION_COMPONENT_ID);
    }
    onAdd(entity) {
        // Cabinets can move between sections and wall/floor and in that case the DistanceMeasurementComponent needs to be updated
        if (!this.coreApi.entities.isOneOfProductTypes(entity, [
            ProductType.BROR_CABINET_BLACK,
            ProductType.BROR_CABINET_GREEN
        ])) {
            return;
        }
        const directions = entity.getComponent(DistanceMeasurementComponent.id)?.directions;
        if (this.placedInSection(entity) && directions && directions?.length !== 2) {
            // Cabinet moved from floor/wall into section. Show measurements up and down
            entity.addComponent(new DistanceMeasurementComponent([Direction.UP, Direction.DOWN], [Direction.UP]));
        }
        else if (!this.placedInSection(entity) && directions && directions?.length !== 4) {
            // Cabinet moved from section out to wall. Show measurements in all directions
            entity.addComponent(new DistanceMeasurementComponent([
                Direction.UP,
                Direction.DOWN,
                Direction.LEFT,
                Direction.RIGHT
            ]));
        }
    }
    onUpdate() { }
    onRemove() { }
    placedInSection(entity) {
        const parent = HierarchyUtils.parent(entity);
        return ((parent && this.coreApi.entities.isProductType(parent, ProductType.BROR_SECTION)) || false);
    }
}
//# sourceMappingURL=BrorDistanceMeasurementSystem.js.map